/**
 * @prop --cbp-form-field-color: var(--cbp-color-text-darkest);
 * @prop --cbp-form-field-color-bg: var(--cbp-color-white);
 * @prop --cbp-form-field-color-border: var(--cbp-color-interactive-secondary-base);
 * @prop --cbp-form-field-color-border-hover: var(--cbp-color-interactive-secondary-darker);
 * @prop --cbp-form-field-color-border-focus: var(--cbp-color-interactive-focus-dark);
 * @prop --cbp-form-field-color-label: var(--cbp-color-text-darkest);
 * @prop --cbp-form-field-color-description: var(--cbp-color-text-darkest);
 * @prop --cbp-form-field-color-placeholder: var(--cbp-color-text-dark);

 * @prop --cbp-form-field-color-dark: var(--cbp-color-text-lightest);
 * @prop --cbp-form-field-color-bg-dark: var(--cbp-color-gray-cool-70);
 * @prop --cbp-form-field-color-border-dark: var(--cbp-color-interactive-secondary-light);
 * @prop --cbp-form-field-color-border-hover-dark: var(--cbp-color-interactive-secondary-lighter);
 * @prop --cbp-form-field-color-border-focus-dark: var(--cbp-color-interactive-focus-light);
 * @prop --cbp-form-field-color-label-dark: var(--cbp-color-text-lightest);
 * @prop --cbp-form-field-color-description-dark: var(--cbp-color-text-lightest);
 * @prop --cbp-form-field-color-placeholder-dark: var(--cbp-color-text-light);

 * @prop --cbp-form-field-padding-inline: var(--cbp-space-2x);
 * @prop --cbp-form-field-margin-bottom: var(--cbp-space-4x);
 * @prop --cbp-form-field-border-radius: var(--cbp-border-radius-soft);
 */
 :root{
  --cbp-form-field-color: var(--cbp-color-text-darkest);
  --cbp-form-field-color-bg: var(--cbp-color-white);
  --cbp-form-field-color-border: var(--cbp-color-interactive-secondary-base);
  --cbp-form-field-color-border-hover: var(--cbp-color-interactive-secondary-darker);
  --cbp-form-field-color-border-focus: var(--cbp-color-interactive-focus-dark);
  --cbp-form-field-color-label: var(--cbp-color-text-darkest);
  --cbp-form-field-color-description: var(--cbp-color-text-darkest);
  --cbp-form-field-color-placeholder: var(--cbp-color-text-dark);

  --cbp-form-field-color-dark: var(--cbp-color-text-lightest);
  --cbp-form-field-color-bg-dark: var(--cbp-color-gray-cool-70);
  --cbp-form-field-color-border-dark: var(--cbp-color-interactive-secondary-light);
  --cbp-form-field-color-border-hover-dark: var(--cbp-color-interactive-secondary-lighter);
  --cbp-form-field-color-border-focus-dark: var(--cbp-color-interactive-focus-light);
  --cbp-form-field-color-label-dark: var(--cbp-color-text-lightest);
  --cbp-form-field-color-description-dark: var(--cbp-color-text-lightest);
  --cbp-form-field-color-placeholder-dark: var(--cbp-color-text-light);

  --cbp-form-field-padding-inline: var(--cbp-space-2x);
  --cbp-form-field-margin-bottom: var(--cbp-space-4x);
  --cbp-form-field-border-radius: var(--cbp-border-radius-soft);

  // TechDebt: Ideally, it would be better if the icon could inherit the text color, but I can't seem to get this working so we have 2 copies with different colors
  // On light bg
  //--cbp-form-field-select-chevron: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512" fill="%231b1b1b"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>');
  //--cbp-form-field-select-chevron-dark: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512" fill="%23fcfcfc"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>');
  
  // On dark "button" background
  --cbp-form-field-select-chevron: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512" fill="%23fcfcfc"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>');
  --cbp-form-field-select-chevron-dark: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512" fill="%231b1b1b"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>');

}

// Displays dark design based on mode or context
[data-cbp-theme=light] cbp-form-field[context*=dark],
[data-cbp-theme=dark] cbp-form-field:not([context=dark-inverts]):not([context=light-always]) {
  --cbp-form-field-color-label: var(--cbp-form-field-color-label-dark) !important;
  --cbp-form-field-color-description: var(--cbp-form-field-color-description-dark) !important;
  --cbp-form-field-color: var(--cbp-form-field-color-dark) !important;
  --cbp-form-field-color-bg: var(--cbp-form-field-color-bg-dark) !important;
  --cbp-form-field-color-border: var(--cbp-form-field-color-border-dark) !important;
  --cbp-form-field-color-border-hover: var(--cbp-form-field-color-border-hover-dark) !important;
  --cbp-form-field-color-border-focus: var(--cbp-form-field-color-border-focus-dark) !important;
  --cbp-form-field-color-placeholder: var(--cbp-form-field-color-placeholder-dark) !important;
  --cbp-form-field-select-chevron: var(--cbp-form-field-select-chevron-dark) !important;
}

cbp-form-field {
  display: block;
  margin-bottom: var(--cbp-form-field-margin-bottom);

  fieldset,
  legend {
    all: unset;
  }

  fieldset{
    display: block;
  }

  .cbp-form-field-label {
    display: block;
    color: var(--cbp-form-field-color-label);
    font-size: var(--cbp-font-size-body);
    font-weight: var(--cbp-font-weight-bold);
    font-style: italic;
    line-height: var(--cbp-line-height-xs);
  }

  .cbp-form-field-description {
    display: block;
    color: var(--cbp-form-field-color-description);
    font-size: var(--cbp-font-size-subhead);
    font-weight: var(--cbp-font-weight-medium);
    font-style: italic;
    line-height: var(--cbp-line-height-xs);
    margin-bottom: var(--cbp-space-1x);
  }

  .cbp-form-field-container {
    position: relative;
  }

  input,
  textarea,
  select, 
  .cbp-custom-form-control {
    width: 100%;
    max-width: 100%;
    min-height: var(--cbp-space-9x);
    padding-inline: var(--cbp-form-field-padding-inline);
    font-family: inherit;
    font-size: var(--cbp-font-size-body);
    line-height: var(--cbp-line-height-xs);
    text-align: start;
    vertical-align: middle;

    color: var(--cbp-form-field-color);
    background-color: var(--cbp-form-field-color-bg);
    border-style: solid;
    border-width: var(--cbp-border-size-md);
    border-color: var(--cbp-form-field-color-border);
    border-radius: var(--cbp-form-field-border-radius);
    outline-style: solid;
    outline-width: 0;
    outline-color: var(--cbp-form-field-color-border-focus);
    outline-offset: -1px; // Verified: Safari does not show focus outline without this

    scrollbar-width: thin;
    scrollbar-color: var(--cbp-form-field-color-border) var(--cbp-form-field-color-bg);

    // Verified: styling textarea and (multi)select scrollbars in Safari
    &::-webkit-scrollbar {
      width: var(--cbp-space-1x);
    }

    &::-webkit-scrollbar-track {
      background-color: var(--cbp-form-field-color-bg);
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--cbp-form-field-color-border);
    }

    &:hover {
      --cbp-form-field-color-border: var(--cbp-form-field-color-border-hover); // this makes the scrollbars update dynamically
    }

    &:focus,
    &:focus-visible {
      --cbp-form-field-color-border: var(--cbp-form-field-color-border-focus); // this makes the scrollbars update dynamically
      outline-width: var(--cbp-border-size-lg); // This is set to 3px because of the 1px inset, overlapping the border; border+outline = 4px total.
      //border-color: var(--cbp-form-field-color-border-focus);
    }

    &[readonly],
    &:disabled {
      font-style: italic;
      cursor: not-allowed;
    }
  }
  
  // These overrides need to be set at the component host level to work properly in dark mode
  &[disabled],
  &:has(:not(button):disabled) {
    --cbp-form-field-color: var(--cbp-color-interactive-disabled-dark);
    --cbp-form-field-color-bg: var(--cbp-color-interactive-disabled-light);
    --cbp-form-field-color-border: var(--cbp-color-interactive-disabled-dark);
    --cbp-form-field-color-border-hover: var(--cbp-color-interactive-disabled-dark);
    //--cbp-form-field-color-border-focus: var(--cbp-color-interactive-disabled-dark);
    --cbp-form-field-color-dark: var(--cbp-color-interactive-disabled-light);
    --cbp-form-field-color-bg-dark: var(--cbp-color-interactive-disabled-dark);
    --cbp-form-field-color-border-dark: var(--cbp-color-interactive-disabled-light);
    --cbp-form-field-color-border-hover-dark: var(--cbp-color-interactive-disabled-light);
    //--cbp-form-field-color-border-focus: var(--cbp-color-interactive-secondary-dark);
    --cbp-form-field-color-placeholder: transparent;
  }

  &[readonly],
  &:has(*[readonly]) {
    --cbp-form-field-color-bg: var(--cbp-color-gray-cool-10);
    --cbp-form-field-color-border: var(--cbp-color-interactive-secondary-light);
    --cbp-form-field-color-border-hover: var(--cbp-color-interactive-secondary-light);
    --cbp-form-field-color-border-focus: var(--cbp-color-interactive-secondary-light);
    --cbp-form-field-color-bg-dark: var(--cbp-color-gray-cool-80);
    --cbp-form-field-color-border-dark: var(--cbp-color-interactive-secondary-dark);
    --cbp-form-field-color-border-hover-dark: var(--cbp-color-interactive-secondary-dark);
    --cbp-form-field-color-border-focus: var(--cbp-color-interactive-secondary-dark);
    --cbp-form-field-color-placeholder: transparent;

    // For readonly inputs, attached buttons become disabled but with different styling.
    // These overrides are fairly minimal because the disabled state already sets the interactive states to the base color.
    cbp-button[fill=solid]:has(button:disabled) {
      --cbp-button-color: var(--cbp-color-text-lightest);
      --cbp-button-color-bg: var(--cbp-color-white);
      --cbp-button-color-border: var(--cbp-form-field-color-border);

      --cbp-button-color-dark: var(--cbp-color-text-base);
      --cbp-button-color-bg-dark: var(--cbp-form-field-color-border-dark);
      --cbp-button-color-border-dark: var(--cbp-form-field-color-border-dark);
    }

    cbp-button[fill=outline]:has(button:disabled) {
      --cbp-button-color: var(--cbp-color-interactive-secondary-base);
      --cbp-button-color-bg: var(--cbp-color-interactive-secondary-light);
      --cbp-button-color-border: var(--cbp-color-interactive-secondary-base);

      --cbp-button-color-dark: var(--cbp-color-interactive-secondary-base);
      --cbp-button-color-bg-dark: var(--cbp-form-field-color-bg-dark);
      --cbp-button-color-border-dark: var(--cbp-color-interactive-secondary-base);
    }
  }

  ::placeholder {
    color: var(--cbp-form-field-color-placeholder);
    font-style: italic;
  }


  // File Inputs
  input[type=file]{
    line-height: var(--cbp-space-8x);
  }
  ::file-selector-button {
    display: none;
  }
  
  // Textarea
  textarea { 
    min-height: 6.75rem;
    max-height: 80vh;
    padding-block: var(--cbp-space-2x);
    resize: vertical;
  }

  // Select and Dropdowns
  select,
  cbp-dropdown .cbp-custom-form-control {
    appearance: none;
    text-overflow: ellipsis;
    padding-block: calc(var(--cbp-space-2x) - 2px) ; // Fixes Firefox vertical alignment

    option {
      // only allows color and bgcolor to be changed in most browsers - these seem to be inherited in Chrome and Firefox already (not safari)
      color: var(--cbp-form-field-color);
      background-color: var(--cbp-form-field-color-bg);
    }

    // Safari is lacking in contrast, so these need to be manually set
    optgroup {
      color: var(--cbp-form-field-color);
      background-color: var(--cbp-form-field-color-bg);
      font-weight: var(--cbp-font-weight-bold);
    }
  }

  // Selects do not allow ::before pseudo element for a faux-button, so this is implemented differently than cbp-dropdown.
  select:not([multiple]):not([size]) {
    // Simple chevron replacement, no background
    //background: right var(--cbp-space-2x) top var(--cbp-space-3x) no-repeat var(--cbp-form-field-color-bg) var(--cbp-form-field-select-chevron);
    //padding-inline-end: var(--cbp-space-5x);

    // Extract the width of the faux button for easier calculations
    --cbp-form-field-dropdown-faux-button-width: calc(var(--cbp-space-9x) - var(--cbp-border-size-md));

    // Chevron on a colored background (via linear gradient)
    background: right calc( calc(var(--cbp-form-field-dropdown-faux-button-width) / 2 ) - 8px) top calc(1rem - 8px) no-repeat var(--cbp-form-field-select-chevron), 
                right -0.4px top 0px repeat-y linear-gradient( 90deg, var(--cbp-form-field-color-bg) calc(100% - var(--cbp-form-field-dropdown-faux-button-width)), var(--cbp-form-field-color-border) var(--cbp-space-9x) );
    padding-inline-end: var(--cbp-space-9x);
    
  }

  // Leave commented styles until verified everything's correct. If so, these are being inherited and can be removed.
  &[error] {
    //--cbp-form-field-color: var(--cbp-color-text-darkest);
    --cbp-form-field-color-bg: var(--cbp-color-danger-lighter);
    --cbp-form-field-color-border: var(--cbp-color-danger-dark);
    --cbp-form-field-color-border-hover: var(--cbp-color-danger-darker);
    //--cbp-form-field-color-border-focus: var(--cbp-color-interactive-focus-dark);
    //--cbp-form-field-color-label: var(--cbp-color-text-darkest);
    --cbp-form-field-color-description: var(--cbp-color-danger-dark);
    //--cbp-form-field-color-placeholder: var(--cbp-color-text-dark);
    
    //--cbp-form-field-color-dark: var(--cbp-color-text-lightest);
    --cbp-form-field-color-bg-dark: var(--cbp-color-danger-darker);
    --cbp-form-field-color-border-dark: var(--cbp-color-danger-light);
    --cbp-form-field-color-border-hover-dark: var(--cbp-color-danger-lighter);
    //--cbp-form-field-color-border-focus-dark: var(--cbp-color-interactive-focus-light);
    //--cbp-form-field-color-label-dark: var(--cbp-color-text-lightest);
    --cbp-form-field-color-description-dark: var(--cbp-color-danger-light);
    //--cbp-form-field-color-placeholder-dark: var(--cbp-color-text-light);
  }

  // Auto-filled input background color is set by the user agent stylesheet, so unfortunately there’s no way to override it.
  // Instead of styling the background color, use an inner box shadow that covers the background and use -webkit-text-fill-color to set the text color.
  input:is(:-webkit-autofill, :autofill),
  input:is(:-webkit-autofill, :autofill):focus {
    box-shadow: 0 0 0 1000px var(--cbp-form-field-color-bg) inset;
    -webkit-text-fill-color: var(--cbp-form-field-color);
  }

  // Hide Edge's built-in password reveal control
  ::-ms-reveal {
    display: none;
  }
}


/*
  // This removes the default increment arrows in the number input field
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0; // Margins still appear even if hidden
  }

  input[type=number] {
    -moz-appearance: textfield; // Removes the default increment arrows in Firefox 
  }

*/